<script setup lang="ts">
import BaseIcon from '@/components/base/baseIcon.vue'
import ResearchStatusView from '@/components/base/ResearchStatus.vue'
import ExclusiveBadge from '@/components/badges/ExclusiveBadge.vue'
import { ContentType } from '@/stores/communityResearch/iCommunityResearch'
import { iconNames } from '@/enums/iconNames'
import { pageNames } from '@/enums/pageNames'
import { researchStatus } from '@/enums/researchStatus'
import { getRelatedTag } from '@/service/relatedTag/relatedTag'
import type { iRelatedTag } from '@/stores/relatedResearchTag/relatedResearchTag'
import moment from 'moment'
import { onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'
interface Props {
  researchId: number
  researchTitle: string
  researchCategory: string | null
  contributorImg?: string
  contributorName: string
  relatedTags: string[]
  status: researchStatus
  publishDate: moment.Moment
  deleteDate: moment.Moment | null
  classes?: string
  contentType: ContentType
}
const props = defineProps<Props>()

const fetchedRelatedTag = ref<boolean>(true)
const relatedTagData = ref<iRelatedTag[]>([])

async function requestRelatedTag() {
  fetchedRelatedTag.value = false
  const relatedTagList = await getRelatedTag(props.researchId)
  relatedTagData.value = relatedTagList.data.data as iRelatedTag[]
  fetchedRelatedTag.value = true
}

onBeforeMount(async () => {
  requestRelatedTag()
})

const router = useRouter()
</script>
<template>
  <div
    class="flex flex-col research-card-content-skeleton cursor-pointer"
    :class="[classes]"
    @click="
      () => router.push({ name: pageNames.RESEARCHEDITOREXISTING, params: { id: researchId } })
    "
  >
    <div class="research-card-title break-all">
      {{ researchTitle }}
    </div>
    <div class="flex flex-row research-card-title-neighbour">
      <div class="flex flex-row research-card-contributor">
        <img :src="contributorImg" class="research-card-img-contributor rounded-[8px]" />
        <div class="research-card-contributor-name flex items-center">{{ contributorName }}</div>
      </div>
      <div class="research-card-separator flex items-center">|</div>
      <div
        class="research-card-category flex items-center"
        v-if="
          status === researchStatus.APPROVED ||
          status === researchStatus.REJECTED ||
          researchCategory !== null
        "
      >
        {{ researchCategory }}
      </div>
      <div class="research-card-category-missing flex items-center" v-else>
        UPDATE CATEGORY NEEDED!
      </div>
    </div>
    <!-- [Deprecated] related tag is disabled -->
    <!-- <div class="flex flex-col lg:flex-row justify-start">
      <div class="flex lg:flex-none items-center">
        <span class="research-card-relatedtag-label">Related Tags:</span>
      </div>
      <div class="block lg:grow flex-row lg:ml-auto">
        <div class="block lg:flex research-card-related-tag lg:justify-end">
          <div
            class="inline-flex"
            :class="[
              tag.related_tags !== undefined && tag.related_tags.deleted_at !== null
                ? 'bg-[--algo-system-red-400]'
                : ''
            ]"
            v-for="tag in relatedTagData"
            :key="'relatedTag-' + researchId + '-' + tag.id"
          >
            {{ tag.related_tags.tag_name }}
          </div>
          <div class="inline-flex" v-if="relatedTagData.length < 1">NO TAG ADDED</div>
        </div>
      </div>
    </div> -->
    <div v-if="props.contentType === ContentType.EXCLUSIVE" class="flex mt-[12px]">
      <ExclusiveBadge title="Exclusive"/>
    </div>
    <div class="my-[12px] border-b border-[#cbd5e1]"></div>
    <div class="flex flex-row justify-start">
      <div class="flex sm:flex-row flex-col items-center gap-[16px]">
        <ResearchStatusView :status="status" :is-deleted="deleteDate !== null" />
        <!-- <div class="flex content-center items-center label-status">{{ status }}</div> -->
        <div class="flex flex-row header-card-bottom-detail">
          <span><BaseIcon :icon-name="iconNames.CALENDAR" :size="20" /></span>
          <span class="flex items-center research-card-published-date">{{
            publishDate.format('D MMM YYYY')
          }}</span>
        </div>
      </div>
      <div class="flex ml-auto sm:mt-0 mt-auto">
        <button><BaseIcon :icon-name="iconNames.GOTO" :size="20" /></button>
      </div>
    </div>
  </div>
</template>
<style>
@import '@/assets/algo-css/components/SimpleResearchCard.css';
</style>
